module.exports = __webpack_public_path__ + "img/logo1.39f41857.png";